module.exports = __webpack_public_path__ + "static/media/shekel-sign.88003c90.svg";